/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const debugEnabled = (flag: string): boolean =>
	(process.env.JFE_DEBUG || '').split(',').includes(flag);
